(() => {
  const boot = () => document.querySelectorAll('[data-poho-root]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const role = root.dataset.themeRole || window.Shopify?.theme?.role;
    if (role && role.toLowerCase() !== 'main') root.querySelectorAll('[data-poho-link]').forEach(a => {
      const url = new URL(a.href, location.origin);
      url.searchParams.set('preview_theme_id', root.dataset.themeId || window.Shopify?.theme?.id);
      a.href = url.href;
    });
    const film = root.querySelector('.poho-film');
    const filmToggle = root.querySelector('[data-video-toggle]');
    if (film && filmToggle) {
      const update = () => {filmToggle.textContent = film.paused ? 'Play video' : 'Pause video';filmToggle.setAttribute('aria-pressed', String(!film.paused));};
      film.muted = true;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) film.pause();
      else film.play().catch(update);
      film.addEventListener('play', update);film.addEventListener('pause', update);
      filmToggle.addEventListener('click', () => {if(film.paused) film.play().catch(update);else film.pause();});
      update();
    }
    const form = root.querySelector('[data-poho-form]');
    if (!form) return;
    const select = form.querySelector('select[name="id"]');
    const submit = form.querySelector('[type="submit"]');
    const alert = form.querySelector('[role="alert"]');
    const preview = form.dataset.open !== 'true';
    const options = [...select.options];
    const kind = root.dataset.formKind;
    const needsAvailability = !preview && ['vendor','sponsor'].includes(kind);
    let availabilityReady = !needsAvailability;
    const updateBooths = () => root.querySelectorAll('[data-booth]').forEach(button => {
      const option = options.find(item => item.value === button.dataset.booth);
      const blocked = ['I','J','K','L','M'].includes(button.dataset.letter);
      button.disabled = blocked || !option || option.disabled;
      button.classList.toggle('is-unavailable', !blocked && button.disabled);
    });
    updateBooths();
    const showError = message => {alert.textContent=message;alert.hidden=false;};
    const selection = () => {
      const option=select.selectedOptions[0];
      root.querySelectorAll('[data-booth]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.booth===select.value)));
      root.querySelectorAll('[data-package-card]').forEach(c=>c.classList.toggle('is-selected',c.dataset.packageCard===select.value));
      const booth=[...root.querySelectorAll('[data-booth]')].find(b=>b.dataset.booth===select.value);
      if(booth){
        root.querySelector('[data-selection-title]').textContent='Space '+booth.dataset.letter+' selected';
        root.querySelector('[data-selection-detail]').textContent='$'+booth.dataset.fee+' after approval · $0 application checkout';
        form.querySelector('#PohoBoothProperty').value=booth.dataset.letter;
        form.querySelector('#PohoFeeProperty').value='$'+booth.dataset.fee;
      }
      submit.disabled=preview || !availabilityReady || !option || option.disabled || !option.value;
    };
    root.querySelectorAll('[data-booth],[data-package]').forEach(button=>button.addEventListener('click',()=>{
      const value=button.dataset.booth||button.dataset.package;
      const option=options.find(o=>o.value===value);
      if(!option||option.disabled||button.disabled)return;
      select.value=value;selection();
      if(button.dataset.package){form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});select.focus({preventScroll:true});}
    }));
    select.addEventListener('change',selection);selection();
    form.querySelectorAll('input[type="file"]').forEach(input=>input.addEventListener('change',()=>{
      input.setCustomValidity('');
      const file=input.files[0];
      if(file && file.size>10*1024*1024)input.setCustomValidity('Please choose a file smaller than 10 MB.');
      input.reportValidity();
    }));
    form.addEventListener('submit',event=>{
      if(preview){event.preventDefault();showError('This is a preview. Applications and purchases are not open yet.');return;}
      if(submit.disabled){event.preventDefault();showError('Select an available option before continuing.');return;}
      if(!form.reportValidity()){event.preventDefault();return;}
      if(form.dataset.submitting){event.preventDefault();return;}
      form.dataset.submitting='true';submit.disabled=true;submit.textContent='Opening your cart…';
    });
    if(needsAvailability){
      const handles={vendor:'2027-poho-hotrod-fest-vendor-space',sponsor:'2027-poho-hotrod-fest-sponsorship'};
      let refreshing=false;
      const refresh=async()=>{
        if(refreshing)return;
        refreshing=true;
        try{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'products/'+handles[kind]+'.js',{cache:'no-store'});
          if(!response.ok)throw new Error('Availability unavailable');
          const product=await response.json();
          for(const option of options){
            if(!option.value)continue;
            const variant=product.variants.find(v=>String(v.id)===option.value);
            const button=root.querySelector('[data-booth="'+option.value+'"],[data-package="'+option.value+'"]');
            const blocked=button && ['I','J','K','L','M'].includes(button.dataset.letter);
            option.disabled=!variant?.available || blocked;
            if(variant)option.textContent=variant.title+(option.disabled?' — UNAVAILABLE':'');
            if(button){button.disabled=option.disabled;button.classList.toggle('is-unavailable',!blocked && !variant?.available);}
          }
          availabilityReady=true;
          alert.hidden=true;
          updateBooths();selection();
        }catch(error){availabilityReady=false;submit.disabled=true;showError('Availability could not be checked. Refresh the page before continuing.');}
        finally{refreshing=false;}
      };
      refresh();
      document.addEventListener('visibilitychange',()=>{if(!document.hidden && root.isConnected)refresh();});
      window.addEventListener('focus',()=>{if(root.isConnected)refresh();});
      const timer=setInterval(()=>{if(!document.hidden && root.isConnected)refresh();else if(!root.isConnected)clearInterval(timer);},15000);
    }
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
